module.exports = __webpack_public_path__ + "img/violet_088.ce3204f4.png";